import React from "react";
import RightSectionEM from "../educationMamaComponents/RightSectionEM/RightSectionEM";
import Leads from "../educationMamaComponents/Leads/Leads";
import HeaderComponent from "./HeaderComponent";

const FeedComponentForEM = () => {
  return (
    <div className="FeedComponent FeedComponentForTeacher">
      <HeaderComponent
      // whiteLabel={this.state.isWhiteLabel}
      // headerData={{ studentName: this.state.teacherInfo.user_name }}
      />
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">

            {/* <div className="col-md-12">

            <div className="text-center" style={{padding: "10vh 0" , color:"#343A40"}}>
              <h1>Temporarily Down for Maintenance</h1>
              <p>We are performing scheduled maintenance, we will be back online shortly</p>
              <i className="fas fa-smile-beam fa-5x animated infinite pulse"></i>
            </div>

            </div> */}

            <div className="col-md-3">
              <RightSectionEM />
            </div>
  
            <div className="col-md-9">
          
             
              <Leads />
           
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedComponentForEM;
